/**
 * BillingHoldOverlay — a polite, blocking access-paused message.
 *
 * Covers the full screen with a blurred backdrop (the journey shows faintly
 * behind but cannot be interacted with — the overlay captures all pointer
 * events). Shown when a journey is on billing hold: the client has an open
 * balance beyond the point where portal access can be maintained.
 *
 * NOTE: this overlay sits below the admin TestPanel (z-index) so the panel
 * stays reachable to toggle the state off.
 */

export default function BillingHoldOverlay({ firmName = 'Alder James', payUrl }) {
  return (
    <div style={S.scrim}>
      <div style={S.card}>
        <div style={S.eyebrow}>Access paused</div>
        <h2 style={S.title}>Account balance needs attention</h2>
        <hr style={S.rule} />
        <p style={S.body}>
          There is an outstanding balance on your account. Once it is brought current, your access
          resumes immediately and everything will be just as you left it.
        </p>
        {payUrl && (
          <div style={{ marginTop: 22, textAlign: 'center' }}>
            <a href={payUrl} target="_blank" rel="noopener noreferrer" style={S.payBtn}>
              Pay your balance
            </a>
          </div>
        )}
        <p style={{ ...S.body, color: '#7a9aaa', fontSize: 13, marginTop: 22 }}>
          {payUrl
            ? 'After paying, refresh this page to restore access. Payments made online may take a day or two to appear.'
            : `Please contact your team at ${firmName} to bring your account current.`}
        </p>
        {payUrl && (
          <div style={{ textAlign: 'center', marginTop: 14 }}>
            <button onClick={() => window.location.reload()} style={S.refreshBtn}>
              Refresh status
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

const S = {
  scrim: {
    position: 'fixed', inset: 0, zIndex: 100,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
    background: 'rgba(4,21,24,0.55)',
    backdropFilter: 'blur(10px)', WebkitBackdropFilter: 'blur(10px)',
  },
  card: {
    width: '100%', maxWidth: 520, textAlign: 'center',
    background: 'rgba(255,255,255,0.96)', backdropFilter: 'blur(10px)',
    border: '0.5px solid rgba(255,255,255,0.6)', borderRadius: 16,
    boxShadow: '0 24px 64px rgba(4,21,24,0.5)', padding: 'clamp(32px, 5vw, 52px)',
  },
  eyebrow: {
    fontFamily: '"Montserrat", sans-serif', fontSize: 10, fontWeight: 500,
    letterSpacing: '0.24em', textTransform: 'uppercase', color: '#c0392b', marginBottom: 16,
  },
  title: {
    fontFamily: '"Montserrat", sans-serif', fontSize: 'clamp(20px, 2.6vw, 27px)',
    fontWeight: 300, letterSpacing: '0.03em', color: '#07272D', lineHeight: 1.3, margin: 0,
  },
  rule: { height: '0.5px', background: 'rgba(7,39,45,0.12)', border: 'none', margin: '24px auto', width: 60 },
  body: { fontFamily: '"DM Sans", sans-serif', fontSize: 15, lineHeight: 1.7, color: '#3a5260', margin: '0 0 12px' },
  payBtn: {
    display: 'inline-block', fontFamily: '"DM Sans", sans-serif', fontSize: 14, fontWeight: 600,
    color: '#fff', background: '#07272D', textDecoration: 'none',
    padding: '12px 28px', borderRadius: 8,
  },
  refreshBtn: {
    fontFamily: '"DM Sans", sans-serif', fontSize: 12, fontWeight: 500, color: '#7a9aaa',
    background: 'none', border: '0.5px solid rgba(7,39,45,0.15)', borderRadius: 6,
    padding: '7px 16px', cursor: 'pointer',
  },
}
